import React from 'react';
import { Text } from '@fluentui/react-components';
import { IconButton } from '@fluentui/react';
// import { Attach20Regular } from '@fluentui/react-icons';
import { useNavigate } from 'react-router-dom';
import { P } from '../Pages-styles';
import { usePageContext } from '../../hooks/PageContext';
import { Note } from '../../graphql/types';

interface ArticleCardProps {
  note: Note;
}

export const ArticleCard: React.FC<ArticleCardProps> = ({ note }) => {
  const { actions, isAuthenticated } = usePageContext();
  const navigate = useNavigate();

  const {
    setCurrentNote,
    setMode,
    setTagFilter,
    setSearch,
    setIsCreating,
    setForm,
    handleToggleFavorite,
    selectedNotes,
    setSelectedNotes,
    isAdmin,
    user,
  } = actions;

  const isFavorite =
    isAuthenticated && note.favoritedBy.some((u: { id: string }) => u.id === user?.id);

  return (
    <div
      style={{
        cursor: 'pointer',
        padding: '10px',
        borderRadius: '0px',
        border: '1px solid #f3f2f1',
        backgroundColor: '#fff',
        transition: 'all 0.2s',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        height: '300px',
        overflow: 'hidden',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        width: '100%',
        // ✅ ДОБАВЛЕНА ТЕНЬ ДЛЯ ОБЪЁМА
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.15)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
      }}
      onClick={() => {
        setCurrentNote(note);
        setMode('view');
        navigate(`/blog/${note.id}`);
      }}
    >
    {/* Превью — на всю ширину карточки, без отступов */}
    {note.previewImage && (
      <div style={{ 
        margin: '-10px -10px 10px -10px', // Компенсируем padding карточки
        overflow: 'hidden',
      }}>
        <img
          src={note.previewImage}
          alt="Превью"
          style={{
            width: '100%',
            height: '140px',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </div>
    )}

      <div style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
        {/* Избранное */}
        {isAuthenticated && (
          <IconButton
            iconProps={{
              iconName: 'FavoriteStar',
              style: isFavorite ? { color: 'gold' } : { color: 'inherit' },
            }}
            title="Избранное"
            onClick={(e) => {
              e.stopPropagation();
              handleToggleFavorite(note.id);
            }}
            style={{
              position: 'absolute',
              top: '8px',
              right: '8px',
              zIndex: 1,
              width: '32px',
              height: '32px',
              minWidth: 0,
              border: 'none',
              boxShadow: 'none',
              padding: 0,
            }}
          />
        )}

        {/* Основное изображение (если отличается) */}
        {note.image && note.image !== note.previewImage && (
          <img
            src={note.image}
            alt={note.title}
            style={{
              width: '100%',
              height: '120px',
              objectFit: 'cover',
              borderRadius: '4px',
              marginBottom: '10px',
            }}
          />
        )}

        {/* Заголовок */}
        <Text
          weight="bold"
          style={{
            fontSize: '14px',
            marginBottom: '6px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {note.title}
        </Text>

        {/* Контент (ограничен 2 строки) */}
        <P
          style={{
            margin: '6px 0',
            color: '#555',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            fontSize: '13px',
            lineHeight: '1.5',
            flex: 1,
            wordWrap: 'break-word',
            textOverflow: 'ellipsis',
          }}
        >
          {note.content.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ')}
        </P>

        {/* Теги */}
        {note.tags.length > 0 && (
          <div
            style={{
              display: 'flex',
              gap: '6px',
              flexWrap: 'wrap',
              marginTop: '6px',
              maxHeight: '50px',
              overflow: 'hidden',
            }}
          >
            {note.tags.map((tag: string) => (
              <span
                key={tag}
                style={{
                  color: '#0078d4',
                  fontWeight: 500,
                  fontSize: '12px',
                  cursor: 'pointer',
                  padding: '2px 6px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '80px',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setMode('list');
                  setTagFilter(tag);
                  setSearch('');
                  navigate('/blog', { replace: true });
                }}
              >
                #{tag}
              </span>
            ))}
          </div>
        )}
      </div>

      {/* Строка вложений — всегда внизу 
      <div
        style={{
          marginTop: 'auto',
          paddingTop: '6px',
          paddingBottom: '6px',
          borderTop: '1px solid #f3f2f1',
          backgroundColor: '#f9f9f9',
          color: '#242424',
          fontSize: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          minHeight: '28px',
          borderRadius: '0 0 6px 6px',
          paddingLeft: '8px',
        }}
      >
        <Attach20Regular style={{ color: '#0078d4', flexShrink: 0 }} />
        <span style={{ fontWeight: 'normal' }}>
          Вложения: <strong>{note.attachments?.length || 0}</strong>
        </span>
      </div> */}

      {/* Админ-панель — всегда внизу */}
      {isAdmin && (
        <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '8px' }}>
          <IconButton
            iconProps={{ iconName: 'Edit' }}
            title="Редактировать"
            onClick={(e) => {
              e.stopPropagation();
              setForm({
                title: note.title,
                content: note.content,
                image: note.image || '',
                previewImage: note.previewImage || '',
                tags: note.tags.join(', '),
                attachments: note.attachments || [],
              });
              setCurrentNote(note);
              setIsCreating(false);
              setMode('edit');
            }}
            style={{ width: '32px', height: '32px', minWidth: 0, padding: 0 }}
          />
          <div
            style={{
              width: '16px',
              height: '16px',
              borderRadius: '50%',
              border: '2px solid #0078d4',
              background: selectedNotes.has(note.id) ? '#0078d4' : 'transparent',
              cursor: 'pointer',
              alignSelf: 'center',
              marginTop: '2px',
            }}
            onClick={(e) => {
              e.stopPropagation();
              const newSelected = new Set(selectedNotes);
              if (newSelected.has(note.id)) newSelected.delete(note.id);
              else newSelected.add(note.id);
              setSelectedNotes(newSelected);
            }}
          />
        </div>
      )}
    </div>
  );
};